export default __webpack_public_path__ + "static/media/es.5bedf6bf.png";